import { render, staticRenderFns } from "./Confirm2Dialog.vue?vue&type=template&id=13024b7b&"
import script from "./Confirm2Dialog.vue?vue&type=script&lang=js&"
export * from "./Confirm2Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports